import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '@features/auth/hooks/useAuth';
import { LoadingScreen } from '@components/common/LoadingScreen';

export function AuthLayout() {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return <LoadingScreen />;
  }

  // Redirect authenticated users to their dashboard
  if (isAuthenticated && user) {
    const redirectPath = user.rol === 'cliente' ? '/portal/dashboard' : '/admin/dashboard';
    return <Navigate to={redirectPath} replace />;
  }

  return (
    <div className="flex min-h-screen">
      {/* Left side - Branding */}
      <div className="hidden w-1/2 bg-gradient-merino lg:flex lg:flex-col lg:items-center lg:justify-center lg:p-12">
        <div className="max-w-md text-center">
          <div className="mx-auto mb-8 inline-block rounded-2xl bg-white px-6 py-4">
            <img
              src="/logo-merino.png"
              alt="Merino Control de Plagas"
              className="h-16 w-auto object-contain"
            />
          </div>
          <p className="mt-4 text-lg text-white/80">
            Plataforma CRM integral para gestión de servicios de fumigación.
            Controla clientes, citas, técnicos y más desde un solo lugar.
          </p>
          <div className="mt-12 grid grid-cols-3 gap-4">
            <div className="rounded-xl bg-white/10 p-4 backdrop-blur-sm">
              <p className="text-3xl font-bold text-white">500+</p>
              <p className="text-sm text-white/70">Clientes</p>
            </div>
            <div className="rounded-xl bg-white/10 p-4 backdrop-blur-sm">
              <p className="text-3xl font-bold text-white">1,200+</p>
              <p className="text-sm text-white/70">Servicios</p>
            </div>
            <div className="rounded-xl bg-white/10 p-4 backdrop-blur-sm">
              <p className="text-3xl font-bold text-white">98%</p>
              <p className="text-sm text-white/70">Satisfacción</p>
            </div>
          </div>
        </div>
      </div>

      {/* Right side - Auth forms */}
      <div className="flex w-full flex-col items-center justify-center p-8 lg:w-1/2">
        {/* Mobile logo */}
        <div className="mb-8 lg:hidden">
          <img
            src="/logo-merino.png"
            alt="Merino Control de Plagas"
            className="h-12 w-auto object-contain"
          />
        </div>

        <div className="w-full max-w-md">
          <Outlet />
        </div>

        <p className="mt-8 text-center text-sm text-gray-500">
          © 2025 Merino Control de Plagas. Colima, México.
        </p>
      </div>
    </div>
  );
}

